// Typelizer digest 97871c70fae43f60cc9a4232ed560f88
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/ledger/trust_rules */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/ledger/trust_rules', {}, options),
    method: 'post',
  }),

  /** DELETE /c/:company_id/ledger/trust_rules/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/ledger/trust_rules/:id', params, options),
    method: 'delete',
  }),
}
